import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../assets/styles/tokens";
import { useSearchParams } from "react-router-dom";
import { AppBar, Fab } from "@mui/material";
import CAC from "./CAC/CAC";
import ClickImpression from "./ClickImpression/ClickImpression";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CreateTasksDrawer from "../CreateTrendModules/CreateTrend";

export default function TrendsMobileTabs() {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const tabConfig = [
    { label: "CAC", value: "TrendsMobileCAC" },
    {
      label: "Clicks & Impressions",
      value: "TrendsMobileClicksAndImpressions",
    },
    { label: "CPA", value: "TrendsMobileCPA" },
    { label: "CVR", value: "TrendsMobileCVR" },
    { label: "FTD", value: "TrendsMobileFTD" },
    { label: "PV", value: "TrendsMobilePV", trackerId: "" },
    { label: "PROFIT", value: "TrendsMobileProfit" },
    { label: "RS", value: "TrendsMobileRS" },
  ];
  const [searchParams, setSearchParams] = useSearchParams();

  const currentTabParam = searchParams.get("tabName");

  const initialIndex = tabConfig.findIndex(
    (tab) => tab.value === currentTabParam,
  );

  const [value, setValue] = React.useState(
    initialIndex !== -1 ? initialIndex : 0,
  );

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    const newTabValue = tabConfig[newValue].value;
    searchParams.set("tabName", newTabValue);
    setSearchParams(searchParams);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    value: number;
    index: number;
  }

  function TabPanel({ children, value, index }: TabPanelProps) {
    return (
      <div hidden={value !== index}>
        {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
      </div>
    );
  }

  return (
    <>
      <Box sx={{ height: "93vh", overflowY: "auto" }}>
        <AppBar
          position="sticky"
          sx={{
            bgcolor: "background.paper",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-scrollButtons": {
                color: colors.GrayDarkMode[700].$value,
              },
            }}
            TabIndicatorProps={{
              sx: {
                backgroundColor: colors.Brand[600].$value,
                height: spacing.Spacing.xxs.$value,
              },
            }}
          >
            {tabConfig.map((tab, index) => (
              <Tab
                key={tab.value}
                label={tab.label}
                disableRipple
                {...(tab.trackerId && value === index
                  ? { "data-tracker": tab.trackerId }
                  : {})}
                sx={{
                  color: colors.GrayDarkMode[700].$value,
                  textTransform: "none",
                  fontWeight: typography.Font_weight.Regular.$value,
                  minWidth: spacing.Spacing["7xl"].$value,
                  "&.Mui-selected": {
                    color: "#181D27",
                    fontWeight: typography.Font_weight.Medium.$value,
                  },
                  "&:hover": { backgroundColor: "transparent" },
                  "&:first-of-type": {
                    marginLeft: spacing.Spacing["6xl"].$value,
                  },
                }}
              />
            ))}
          </Tabs>
        </AppBar>

        {/* 🔽 TAB CONTENTS */}
        <TabPanel value={value} index={0}>
          <CAC />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <ClickImpression />
        </TabPanel>

        <TabPanel value={value} index={2}>
          CPA
        </TabPanel>

        <TabPanel value={value} index={3}>
          CVR
        </TabPanel>

        <TabPanel value={value} index={4}>
          FTD
        </TabPanel>

        <TabPanel value={value} index={5}>
          PV
        </TabPanel>

        <TabPanel value={value} index={6}>
          PROFIT
        </TabPanel>

        <TabPanel value={value} index={7}>
          RS
        </TabPanel>

        {/* Create Tasks icon */}
        <Fab
          size="medium"
          color="secondary"
          aria-label="Create Tasks"
          onClick={() => setDrawerOpen(true)}
          sx={{
            backgroundColor: colors.Brand[600].$value,
            position: "fixed",
            bottom: spacing.Spacing["4xl"].$value,
            right: spacing.Spacing.xl.$value,
            "&:hover": { backgroundColor: colors.Brand[600].$value },
          }}
        >
          <AutoFixHighIcon />
        </Fab>
        <CreateTasksDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        />
      </Box>
    </>
  );
}
